import ParticlesTs from '../../ParticlesTs';

import { NewsletterForm } from './NewsletterForm';
import { NewsletterStatus } from './NewsletterStatus';
import { useHandleNewsletterForm } from './utils';

export function FooterNewsletter() {
  const { handleSubmit, isRequestOk, setIsRequestOk } =
    useHandleNewsletterForm();

  return (
    <div className="bg-primary-700 py-16 sm:py-24 lg:py-32 relative h-[444px]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 lg:grid-cols-12 lg:gap-8 lg:px-8">
        <div className="flex flex-col gap-2 max-w-xl lg:col-span-7 justify-center">
          <h2 className="text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            Stay ahead in NMR science!
          </h2>
          <p className="text-xl font-semibold text-white">
            Subscribe to our newsletter for the latest updates.
          </p>
        </div>
        <div className="w-full max-w-md lg:col-span-5 min-h-[180px]">
          <div className="bg-white flex gap-x-4 items-center max-w-md min-h-[200px] p-4 rounded-lg shadow-lg w-full z-[10] relative">
            {!isRequestOk ? (
              <NewsletterForm handleSubmit={handleSubmit} />
            ) : (
              <NewsletterStatus setIsRequestOk={setIsRequestOk} />
            )}
          </div>
        </div>
      </div>
      <ParticlesTs
        enableMovingParticle={false}
        isSmall
        id="newsletter-particles"
        className="absolute hidden h-full w-full lg:block lg:h-full top-0 left-0 z-[5]"
      />
    </div>
  );
}
